import Load from 'components/Load';
import React from 'react';
import { Route } from 'react-router-dom';
import basePath from 'utils/basePath';

const AsyncLogin = Load(
  () =>
    import(
      /* webpackChunkName: "login-screen" */ 'modules/authentication/containers/LoginScreen'
    ),
);
const AsyncSignUp = Load(
  () =>
    import(
      /* webpackChunkName: "signup-screen" */ 'modules/authentication/containers/SignupScreen'
    ),
);
const AsyncFamilyFriendlyModal = Load(
  () =>
    import(
      /* webpackChunkName: "family-friendly-modal" */ 'components/FamilyFriendlyModal/FamilyFriendlyModal'
    ),
);
const AsyncBrandVideoModal = Load(
  () =>
    import(/* webpackChunkName: "brand-video" */ 'components/BrandVideoModal'),
);
const AsyncDatePickerContainer = Load(
  () =>
    import(
      /* webpackChunkName: "navbar-filters" */ 'modules/homescreen/containers/DatePicker'
    ),
);
const AsyncPeopleSelector = Load(
  () =>
    import(
      /* webpackChunkName: "navbar-filters" */ 'modules/homescreen/containers/PeopleSelector'
    ),
);
const AsyncLocalSpeaksModal = Load(
  () =>
    import(
      /* webpackChunkName: "navbar-filters" */ 'components/LocalSpeaksModal'
    ),
);
const AsyncMoreFilterContainer = Load(
  () =>
    import(
      /* webpackChunkName: "navbar-filters" */ 'modules/homescreen/containers/MoreFilterContainer'
    ),
);

const ModalOverlays = [
  <Route
    key={'brand-video'}
    path={`${basePath}/brand-video/`}
    component={AsyncBrandVideoModal}
  />,
  <Route
    key={'filter-date'}
    path={`${basePath}/filter/date/`}
    component={AsyncDatePickerContainer}
  />,
  <Route
    key={'filter-guests'}
    path={`${basePath}/filter/guests/`}
    component={AsyncPeopleSelector}
  />,
  <Route
    key={'filter-languages'}
    path={`${basePath}/filter/languages/`}
    component={AsyncLocalSpeaksModal}
  />,
  <Route
    key={'filter-more'}
    path={`${basePath}/filter/more/`}
    component={AsyncMoreFilterContainer}
  />,
  <Route
    key={'family-friendly-modal'}
    path={`${basePath}/family-friendly-modal/`}
    component={AsyncFamilyFriendlyModal}
  />,
  <Route key={'login'} path={`${basePath}/login`} component={AsyncLogin} />,
  <Route key={'signup'} path={`${basePath}/signup`} component={AsyncSignUp} />,
].filter(Boolean);

export default ModalOverlays;
